import { Action } from "@ngrx/store";
import { HistoryStateSelect } from "@store/models/historyStateInfo.model";

export enum HistoryStateInfoType {
	SET_HISTORY = "[HistoryStateInfo] Set history state"
}
export class UpdateHistoryStateInfoAction implements Action {
	readonly type = HistoryStateInfoType.SET_HISTORY;

	//add an optional payload
	constructor(public payload: HistoryStateSelect) {}
}
export type HistoryStateInfoAction = UpdateHistoryStateInfoAction;
